import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import ContactAddressList from '@shared/contact_addresses/ContactAddressList'
import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import Can from '@shared/permissions/Can'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { contactAddressService } from '@services/admin/contactAddressService'
import { salesChannelService } from '@services/admin/salesChannelService'

const AdminContactAddressList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useAdminNotification() as { addJob: (job: unknown) => void }
  const [importModalVisible, setImportModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['data', 'contact_addresses']}
        actions={
          <>
            <Can requiredPermission="contact_addresses:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="contact_addresses:write">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => navigate('/contact_addresses/new')}
              >
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <ContactAddressList
        service={contactAddressService}
        salesChannelService={salesChannelService}
        role="admin"
        showMerchantColumn={false}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
    </div>
  )
}

export default AdminContactAddressList
